type Transformer<T> = (val: T) => T

export const composeFunctions = <T extends any>(...transformers: Transformer<T>[]) => (val: T) => {
  let latestVal = val
  for (const transformer of transformers) {
    latestVal = transformer(latestVal)
  }
  return latestVal
}
